import { ApplicationInviteType } from '../enums/application-invite-type.enum';

export const applicationPrice = new Map<ApplicationInviteType, number>([
  [ApplicationInviteType.APPLICANT, 49],
  [ApplicationInviteType.CO_APPLICANT, 49],
  [ApplicationInviteType.CO_SIGNER, 25],
]);
